import React, { Children } from 'react';
import { getElementName } from '../../../utils';
import { RADIO_CLASS_PREFIX } from '../constants';
import { RADIO_GROUP_CLASS_PREFIX } from '../RadioGroup';

var extendChildrenWithProps = function extendChildrenWithProps(children, additionalProps) {
  var values = [];
  var childrenWithExtendedProps = Children.map(children, function (child) {
    var _a;

    var childName = getElementName(child);
    var value = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.value;

    if (childName !== RADIO_CLASS_PREFIX) {
      console.error("Only @armor/".concat(RADIO_CLASS_PREFIX, " components can be used as children of ").concat(RADIO_GROUP_CLASS_PREFIX));
      return null;
    }

    if (!value) {
      console.error("Ensure that all @armor/".concat(RADIO_CLASS_PREFIX, " components have 'value' property set"));
      return null;
    }

    values.push(value);
    return React.cloneElement(child, additionalProps);
  });
  var uniqueValues = Array.from(new Set(values));

  if (uniqueValues.length < Children.count(children)) {
    console.error("Ensure that all @armor/".concat(RADIO_CLASS_PREFIX, " components have a unique 'value' property set"));
  }

  return childrenWithExtendedProps;
};

export default extendChildrenWithProps;